/**
 * overlayDefaults — constants for the Product modes plan overlays.
 */

/**
 * Defaults for the Cardinals and SunPath Overlays (for Insolation and Axonometric Modes).
 */
export const VIEW = 200
export const PADDING = 12
export const ICON_SIZE = 8

/**
 * Defaults for the Insolation slider / patch geometry.
 */
export const INSOLATION_DEFAULTS = {
  initialAngleDeg: 180, // 12:00
  minAngleDeg:     90,  // 06:00
  maxAngleDeg:     270, // 18:00
  stepDeg:         2.5,
  patchDistance:   260, // length of the sun-cone polygon in SVG units
}

/**
 * SessionStorage keys for the first-run onboarding overlays.
 * Kept here for reference — the canonical key builder is `onboardingSessionKey(modeId)`
 * in OnboardingContext.jsx which namespaces them as `bim:onboarding_seen:<modeId>`.
 */
